import React from 'react';
import { useAgent } from '../AgentProvider';

function ProfilePicker({ onConfigure }) {
  const agent = useAgent();
  const profiles = agent?.meta?.profiles || [];

  if (!agent?.meta) return null;
  if (profiles.length === 0) {
    return agent.meta.isAdmin && onConfigure ? (
      <button type="button" className="dagent-btn dagent-btn--ghost dagent-btn--sm" onClick={onConfigure}>
        Add an agent
      </button>
    ) : (
      <span className="dagent-badge dagent-badge--muted">No agent configured</span>
    );
  }

  const selected = profiles.some((profile) => profile.id === agent.profileId) ? agent.profileId : profiles[0].id;
  return (
    <select className="dagent-select dagent-select--compact" value={selected} onChange={(event) => agent.setProfileId(event.target.value)} aria-label="Agent model">
      {profiles.map((profile) => (
        <option key={profile.id} value={profile.id}>
          {profile.name} · {profile.model}
        </option>
      ))}
    </select>
  );
}

export default ProfilePicker;
